import Hero from "@/components/Hero";
import StatsSection from "@/components/StatsSection";
import ServicesSection from "@/components/ServicesSection";
import PortfolioBento from "@/components/PortfolioBento";
import ProcessTimeline from "@/components/ProcessTimeline";
import PhysicsPlayground from "@/components/PhysicsPlayground";
import No404Promo from "@/components/No404Promo";
import TestimonialScroller from "@/components/TestimonialScroller";
import CTABanner from "@/components/CTABanner";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <div className="content-auto">
        <StatsSection />
      </div>
      <div className="content-auto">
        <ServicesSection />
      </div>
      <div className="content-auto">
        <PortfolioBento />
      </div>
      <div className="content-auto">
        <ProcessTimeline />
      </div>
      <div className="content-auto">
        <PhysicsPlayground />
      </div>
      <div className="content-auto">
        <No404Promo />
      </div>
      <div className="content-auto">
        <TestimonialScroller />
      </div>
      <div className="content-auto">
        <CTABanner />
      </div>
    </div>
  );
}
